<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          소방시설 자체 점검결과 보고서
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">

          <!-- 기본정보 -->
          <m-group label="기본정보" :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" :readonly="true" v-model="form.body.baseInfo.project_name"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" :readonly="true" :value="form.body.baseInfo.com_name"/>
            </m-form>
            <m-form label="점검일자" :value="form.body.baseInfo.check_date" >
              <date-selector class="w-full" v-model="form.body.baseInfo.check_date" />
            </m-form>
            <m-form label="관리감독자" :value="form.body.baseInfo.supervisor" >
              <vs-input class="w-full" v-model="form.body.baseInfo.supervisor"/>
            </m-form>
            <m-form label="점검담당자" :value="form.body.baseInfo.manager" >
              <vs-input class="w-full" v-model="form.body.baseInfo.manager"/>
            </m-form>
          </m-group>
          <m-form class="mb-4" label="점검대상" :value="selectedWorkTypeList">
            <div class="w-full flex flex-wrap" >
              <span
                v-for="(workType, index) in form.body.baseInfo.workTypeTitleList"
                :key="`work_type_list_${index}`">
                <vs-checkbox v-model="form.body.baseInfo.workType[index]"
                             class="mr-4"
                >{{ workType }}</vs-checkbox>
              </span>
            </div>
          </m-form>

          <!-- 점검항목 및 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검항목 및 점검결과" />
          <m-check-table
            title="구분"
            :menus="menuA"
            menu-width="128px"
          >
            <template v-slot:header>
              <check-table-header :division="2" title="해당설비" />
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(2, 1fr)">
                <check-table-body-item
                  v-for="work in form.body.check.checkListA[menu]"
                  :key="work.text"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                />
              </div>
            </template>
          </m-check-table>

          <!-- 소방관련 확인사항 -->
          <m-title style="margin-top: 2rem;" label="소방관련 확인사항" />
          <m-check-table
            title="No."
            :menus="['공통 확인사항']"
          >
            <template v-slot:header>
              <check-table-header :division="1" title="안전조치 및 확인사항"/>
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(1, 1fr)">
                <check-table-body-item
                  v-for="work in form.body.check.checkListB['공통 확인사항']"
                  :key="work.text"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                  :hidden-dot="true"
                />
              </div>
            </template>
          </m-check-table>

          <!-- (시정보완) 지적내용 및 특이사항 / 다음 달 준비내용 -->
          <vs-row style="margin-top: 2rem;">
            <vs-col class="w-1/2">
              <div class="border-y" style="
              height: 50px; background-color: #f9f9f9;
              display: flex; justify-content: center;
              align-items: center; font-size: 14px; font-weight: 500;">
                <span>(시정보완) 지적내용 및 특이사항</span>
              </div>
              <div class="p-4">
                <span v-if="isPrint">{{form.body.check.now}}</span>
                <vs-textarea v-else class="m-0" :rows="10" v-model="form.body.check.now"></vs-textarea>
              </div>
              <div class="p-4 border-y" style="height: 91px; background-color: #f9f9f9; display: grid; grid-template-columns: auto 1fr;">
                <span class="mr-2">※</span>
                <div style="font-size: 14px; font-weight: 400;">점검결과보고서 지적내용에 대해서는 즉시 정비 하기를 바라며, 정비를 하지 않음으로 인하여 발생하는 사고에 대한 책임은 관계인에게 있음을 양지하시기 바랍니다.</div>
              </div>
            </vs-col>
            <vs-col class="w-1/2 border-left">
              <div class="border-y " style="
              height: 50px; background-color: #f9f9f9;
              display: flex; justify-content: center;
              align-items: center; font-size: 14px; font-weight: 500;">
                <span>다음 달 준비내용</span>
              </div>
              <div class="p-4">
                <span v-if="isPrint">{{form.body.check.next}}</span>
                <vs-textarea v-else class="m-0" :rows="10" v-model="form.body.check.next"></vs-textarea>
              </div>
              <div class="p-4 border-y" style="height: 91px; background-color: #f9f9f9;">
                <div style="display: grid; grid-template-columns: auto 1fr;">
                  <span class="mr-2">1.</span>
                  <div style="font-size: 14px; font-weight: 400;">수신기 주, 지구 경종(비상방송)정상상태 유지할 것.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;">
                  <span class="mr-2">2.</span>
                  <div style="font-size: 14px; font-weight: 400;">소방펌프 자동상태유지, 밸브 개방상태 유지할 것.</div>
                </div>
                <div style="display: grid; grid-template-columns: auto 1fr;">
                  <span class="mr-2">3.</span>
                  <div style="font-size: 14px; font-weight: 400;">피난계단 및 소화전 앞 적재물 비치하지 말 것.</div>
                </div>

              </div>

            </vs-col>
          </vs-row>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import CheckTableHeader from '@/views/write/safetycheck/firefighting_self_check/component/CheckTableHeader'
import CheckTableBodyItem from '@/views/write/safetycheck/firefighting_self_check/component/CheckTableBodyItem'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'

export default {
  name: 'FirefightingSelfCheck',
  components: {
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: this.projName,
            com_name: this.comName,
            workTypeTitleList: ['소화설비', '경보설비', '피난설비', '소화용수설비', '소화활동설비', '기타'],
            workType: [false, false, false, false, false, false],
            check_date: '',
            supervisor: '',
            manager: '',

          },
          check: {
            checkListA: {
              '소화설비' : [
                { text: '소화기구 : 소화기(간이소화용구)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '간이스프링클러설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '소화기구 : 자동소화장치', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '물분무소화설비(미분무)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '옥내소화전설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '포소화설비(분말소화설비)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '옥외소화전설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '가스계, 할로겐, 청정, 이산화탄소', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '스프링클러설비(화재조기진압용)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '', isAction: false},
              ],

              '경보설비' : [
                { text: '자동화재탐지설비 및 시각경보기', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상경보설비 : 자동식싸이렌', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '통합감지시설', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상경보설비 : 단독경보형감지기', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '자동화재속보설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상방송설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '누전경보기', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '가스누설경보기', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상경보설비 : 비상벨설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '', isAction: false},
              ],

              '피난설비' : [
                { text: '피난기구 : 피난사다리(승강식, 미끄럼봉)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 피난구유도등', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 완강기(간이)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 통로유도등(거실)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 구조대', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 계단통로유도등', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 다수인피난장비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도등 : 객석유도등', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 공기안전매트(APT의 경우)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '유도표지(공장 다세대)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '피난기구 : 비상구위치 및 피난유도등', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상조명등(휴대용비상조명등)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '인명구조기구 : 방열복, 공기호흡기, 인공소생기', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '기타', data: { '적합': false, '부적합': false, 'N/A': false } },
              ],

              '소화용수설비' : [
                { text: '상수도소화전 또는 채수구', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '', isAction: false},
              ],

              '소화활동설비' : [
                { text: '제연설비(거실, 계단)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '연소방지설비(트렌져)', data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '연결송수관설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '무선통신보조설비', data: { '적합': false, '부적합': false, 'N/A': false } },

                { text: '연결살수설비', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '비상콘센트설비', data: { '적합': false, '부적합': false, 'N/A': false } },
              ],

              '기타' : [
                { text: '방염물품(벽, 커튼, 천정, 및 기타) 육안점검', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '방화셔터', data: { '적합': false, '부적합': false, 'N/A': false } },
              ]
            },
            checkListB: {
              '공통 확인사항' : [
                { text: '1. 각설비 소화설비(해당설비), 경보설비, 소화설비 연동관계(수신기에서 확인)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '2. 피난계단 적치물 현황(사진촬영)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '3. 헤드, 감지기, 유도등, 완강기(피난설비), 소화기 명판, A/V, P/V, Test 밸브 및 Pump 명판, 성능시험', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '4. 각층 및 실 용도변경사항 있는가?, 용도에 적합한가?', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '5. 소방훈련 실시하고 있는가?(사진)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '6. 피난계획도, 소방훈련, 계획서, 작동기능점검표 비치되었는지 확인, 수정할 내용이 있는지 확인(즉시 수정)', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '7. 화재보험가입 확인 : 적합-가입 / 부적합-미가입', data: { '적합': false, '부적합': false, 'N/A': false } },
                { text: '8. 소방안전관리자의 교육이수(소방안전협회) : 적합-이수 / 부적합-미이수', data: { '적합': false, '부적합': false, 'N/A': false } },
              ],
            },
            now: '',
            next: ''
          },

        }
      },

      fileList: [],
      test: 'test',
    }
  },
  computed:{
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.baseInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      for (let i = 0; i < this.form.body.baseInfo.workTypeTitleList.length; i++) {
        if (this.form.body.baseInfo.workType[i]) {
          menus.push(this.form.body.baseInfo.workTypeTitleList[i])
        }
      }
      return menus
    },
    menuResults () {
      return ['적합', '부적합', 'N/A']
    },
    comName () {
      if (this.isUpdateMode) {

      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {

    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      console.log(this.form)
      const projectId = `${this.$route.params.proj_id}`

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {

      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        console.log("create");
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    }
  }
}
</script>

<style scoped>

</style>
